export default "__VITE_ASSET__DHjxz$5$__"